import { render } from "./cabinetBaseView.vue?vue&type=template&id=198660fb&scoped=true&ts=true"
import script from "./cabinetBaseView.vue?vue&type=script&lang=ts"
export * from "./cabinetBaseView.vue?vue&type=script&lang=ts"

import "./cabinetBaseView.vue?vue&type=style&index=0&id=198660fb&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198660fb"]])

export default __exports__